import React, { useEffect, useState } from "react";
import { useTheme } from "@mui/material/styles";
import {
  CardElement,
  Elements,
  useElements,
  useStripe,
} from "@stripe/react-stripe-js";
import { get } from "lodash";
import {
  Alert,
  Avatar,
  Backdrop,
  Button,
  Card,
  CircularProgress,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import MDBox from "components/MDBox";
import UpdateACHPaymentMethod from "./UpdateACHPaymentMethod";
import { updatePaymentMethod } from "store/slice/customer/customerSlice";
import { useDispatch } from "react-redux";
import { getSubscriptionsList } from "store/slice/customer/customerSlice";
import { createSetupIntentACH } from "store/slice/payment/paymentSlice";
import CreditCard from "assets/icons/credit-card.png.png";
import ACH from "assets/icons/ach.png";

import MDTypography from "components/MDTypography";

const UpdatePaymentMethod = (props) => {
  const {
    setUpdateCard,
    setPaymentMethodEdit,
    subscriptionId,
    setSuccessMessage,
    isACHPayment,
    isCardPayment,
    stripePromise,
  } = props;
  const theme = useTheme();
  const stripe = useStripe();
  const elements = useElements();
  const dispatch = useDispatch();
  const [errorAlert, setErrorAlert] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingClientSecret, setLoadingClientSecret] = useState(isACHPayment);
  const [clientSecret, setClientSecret] = useState(null);
  const [isHovered, setIsHovered] = useState(false);
  const [selectedMethod, setSelectedMethod] = useState("");
  console.log("props ====>", props);

  const methods = [
    {
      icon: ACH,
      iconName: "ach",
      label: "ACH",
    },
    {
      icon: CreditCard,
      iconName: "card",
      label: "Card",
    },
  ];

  const filteredMethods = methods.filter((method) => {
    if (isACHPayment) return method.iconName === "ach";
    if (isCardPayment) return method.iconName === "card";
    return true; // default: show all
  });

  useEffect(() => {
    dispatch(createSetupIntentACH({ subscriptionId }))
      .unwrap()
      .then((result) => {
        if (result.success) {
          setClientSecret(result.clientSecret);
        }
        setLoadingClientSecret(false);
      })
      .catch((err) => {
        throw err;
      });
  }, [subscriptionId, setUpdateCard, setPaymentMethodEdit]);

  const handleUpdatePaymentMethod = (stripe, elements) => async (e) => {
    e.preventDefault();
    if (!stripe || !elements) {
      return;
    }
    const cardElement = elements.getElement(CardElement);
    const isInvalid = get(cardElement, "_invalid", false);
    const isEmpty = get(cardElement, "_empty", false);
    const isValid = !(isEmpty || isInvalid);

    if (isValid) {
      setErrorAlert(false);
      setLoading(true);
      const { error, paymentMethod } = await stripe.createPaymentMethod({
        type: "card",
        card: cardElement,
      });
      if (error) {
        setErrorAlert(true);
        setLoading(false);
      } else {
        const params = {
          subscriptionId: subscriptionId,
          paymentMethodId: paymentMethod.id,
          paymentMethodType: "card",
        };
        await dispatch(updatePaymentMethod(params))
          .unwrap()
          .then(async (result) => {
            if (result.success) {
              await dispatch(getSubscriptionsList());
              setUpdateCard(false);
              setPaymentMethodEdit(false);
              setSuccessMessage(true);
            } else {
              setLoading(false);
            }
          })
          .catch((err) => {
            setLoading(false);
            throw err;
          });
      }
    } else {
      setErrorAlert(true);
    }
  };

  const CARD_ELEMENT_OPTIONS = {
    iconStyle: "solid",
    hidePostalCode: false,
    style: {
      base: {
        iconColor: `${theme.palette.secondary.main}`,
        color: `${theme.palette.secondary.main}`,
        fontSize: "18px",
        fontWeight: 500,
        fontSmoothing: "antialiased",
        ":-webkit-autofill": {
          color: "#fce883",
        },
        "::placeholder": {
          color: `${theme.palette.grey[400]}`,
        },
      },
      invalid: {
        color: `${theme.palette.error.main}`,
        ":focus": {
          color: `${theme.palette.error.light}`,
        },
      },
    },
  };

  const options = {
    clientSecret: clientSecret,
    paymentMethodCreation: "manual",
  };

  const handleCardClick = (iconName) => {
    setSelectedMethod(iconName);
  };

  console.log("selected method ===>", selectedMethod);

  return (
    <>
      {!selectedMethod &&
        filteredMethods.map((item) => (
          <>
            <MDBox
              onClick={() => handleCardClick(item.iconName)}
              p={2}
              className="cursor-pointer"
            >
              <Card>
                <MDBox
                  p={1.5}
                  display="flex"
                  alignItems="center"
                  justifyContent="between"
                  onMouseEnter={() => setIsHovered(true)}
                  onMouseLeave={() => setIsHovered(false)}
                >
                  <MDBox
                    display="grid"
                    justifyContent="center"
                    alignItems="center"
                    width="3rem"
                    height="3rem"
                    borderRadius="lg"
                    variant="gradient"
                    p={1}
                  >
                    <Avatar
                      src={item.icon}
                      alt={item.iconName}
                      style={{ width: "100%", height: "100%" }}
                    />
                  </MDBox>
                  <MDBox>
                    <MDTypography
                      variant="subtitle2"
                      color={isHovered ? "info" : "text"}
                      fontWeight="bold"
                    >
                      {item.label}
                    </MDTypography>
                  </MDBox>
                </MDBox>
              </Card>
            </MDBox>
          </>
        ))}

      {!selectedMethod && (
        <Button
          fullWidth
          color="white"
          variant="contained"
          size="small"
          onClick={() => {
            setUpdateCard(false);
            setPaymentMethodEdit(false);
            setSelectedMethod("");
          }}
        >
          Cancel update method
        </Button>
      )}

      {errorAlert && (
        <Alert
          severity="error"
          className="mb-2"
          onClose={() => {
            setErrorAlert(false);
          }}
        >
          Please First Fill Your Card Details
        </Alert>
      )}

      {selectedMethod === "ach" ? (
        !loadingClientSecret &&
        clientSecret && (
          <div>
            <Elements stripe={stripePromise} options={options}>
              <UpdateACHPaymentMethod
                setUpdateCard={setUpdateCard}
                setPaymentMethodEdit={setPaymentMethodEdit}
                subscriptionId={subscriptionId}
                setSuccessMessage={setSuccessMessage}
                clientSecret={clientSecret}
                setErrorAlert={setErrorAlert}
              />
            </Elements>
          </div>
        )
      ) : selectedMethod === "card" ? (
        <>
          <Paper
            variant="outlined"
            className="px-2"
            sx={{ py: 1.3, width: "100%" }}
          >
            <CardElement options={CARD_ELEMENT_OPTIONS} />
          </Paper>

          <MDBox
            display="flex"
            justifyContent="end"
            gap={2}
            mt={2}
            className="text-center"
          >
            <Button
              color="white"
              variant="contained"
              size="small"
              onClick={handleUpdatePaymentMethod(stripe, elements)}
              disabled={loading}
            >
              Submit
            </Button>
            <Button
              color="white"
              variant="contained"
              size="small"
              onClick={() => {
                setUpdateCard(false);
                setPaymentMethodEdit(false);
                setSelectedMethod("");
              }}
            >
              Cancel
            </Button>
          </MDBox>
        </>
      ) : null}
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <Stack direction="column" spacing={1} alignItems="center">
          <CircularProgress color="inherit" />
          <Typography
            variant="h5"
            sx={{ color: "primary.contrastText" }}
            className="mt-4"
          >
            Please wait .....
          </Typography>
        </Stack>
      </Backdrop>
    </>
  );
};

export default UpdatePaymentMethod;
